// extracted by mini-css-extract-plugin
export default {"datePill":"holidays-table_datePill__FpDJx"};